import { Button } from "antd";
import { UpOutlined } from "@ant-design/icons";
import { useEffect, useState, useRef } from "react";

const BackToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [overFooter, setOverFooter] = useState(false);
  const footerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    footerRef.current = document.querySelector("footer");

    const onScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const footerTop =
        footerRef.current?.getBoundingClientRect().top || Infinity;
      setVisible(scrollY > 300);
      const buttonBottomOffset = 96;
      const isOverlapping = footerTop < windowHeight - buttonBottomOffset;
      setOverFooter(isOverlapping);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return visible ? (
    <div className="fixed bottom-6 right-1 z-50">
      <Button
        type="primary"
        htmlType="button"
        shape="circle"
        icon={<UpOutlined />}
        onClick={scrollToTop}
        className={`border-none shadow-lg ${
          overFooter
            ? "bg-[#9fb9db] hover:bg-[#022e6a]"
            : "bg-[#0077B6] hover:bg-[#005f92]"
        }`}
      />
    </div>
  ) : null;
};

export default BackToTop;
